export const PRODUCT_COLOR = [
  'orange',
  'light_blue',
  'cyan',
  'light_red',
  'pink',
  'yellow',
  'colorless'
] as const;
